<!-- Security - LDAP Provider-->
<form  #ldapForm="ngForm" class="mt-20">
  <div>
    <div class="security-category">
      <h5>{{locale.LABEL_LDAP}} {{locale.LABEL_CONFIGURATION}}</h5>
      <!-- Data Model -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required" for="wm-security-ldap-url">{{locale.LABEL_LDAP_URL}}:
        </label>

        <div class="col-xs-9">
          <input id="wm-security-ldap-url" placeholder={{security.placeholder.LDAP_url}} type="text"
            class="form-control app-textbox wm-security-url" name="wm-security-ldap-url" [(ngModel)]="security.url"
            (ngModelOptions)="{'updateOn': 'change blur'}" (change)="onConfigChange()" />
        </div>
      </div>

      <!-- manager user dn -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3" for="wm-security-manager-dn">{{locale.LABEL_MANAGER_DN}}:
        </label>

        <div class="col-xs-9">
          <input id="wm-security-manager-dn" type="text" class="form-control app-textbox" name="wm-security-manager-dn"
            [(ngModel)]="security.managerDn" (ngModelOptions)="{'updateOn': 'change blur'}" />
        </div>
      </div>

      <!-- manager user pwd -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3" for="wm-security-manager-pwd">{{locale.LABEL_MANAGER_PASSWORD}}:
        </label>

        <div class="col-xs-9">
          <input id="wm-security-manager-pwd" type="password" class="form-control app-textbox"
            name="wm-security-manager-pwd" [(ngModel)]="security.managerPassword"
            (ngModelOptions)="{'updateOn': 'change blur'}" />
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_USER}}</h5>

      <!-- user search pattern Field -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-ldap-user-dn-pattern">{{locale.LABEL_USER_SEARCH_PATTERN}}: </label>

        <div class="col-xs-9">
          <input id="wm-security-ldap-user-dn-pattern" placeholder={{security.placeholder.LDAP_userSearchPattern}}
            class="form-control app-textbox" name="wm-security-ldap-user-dn-pattern"
            [(ngModel)]="security.userDnPattern" (ngModelOptions)="{'updateOn': 'change blur'}"
            (change)="onConfigChange()" />
        </div>
      </div>


      <!-- test user dn -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-test-dn">{{locale.LABEL_TEST_USER_NAME}}: </label>

        <div class="col-xs-9">
          <input id="wm-security-test-dn" type="text" class="form-control app-textbox" name="wm-security-test-dn"
            [(ngModel)]="security.testUsername" (ngModelOptions)="{'updateOn': 'change blur'}"
            (change)="onConfigChange()" />
        </div>
      </div>

      <!-- test user pwd -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 required"
          for="wm-security-test-pwd">{{locale.LABEL_TEST_USER_PASSWORD}}: </label>

        <div class="col-xs-9">
          <input id="wm-security-test-pwd" type="password" class="form-control app-textbox" name="wm-security-test-pwd"
            [(ngModel)]="security.testPassword" (ngModelOptions)="{'updateOn': 'change blur'}"
            (change)="onConfigChange()" />
        </div>
      </div>

      <div class="form-group app-composite-widget clearfix">
        <div class="col-xs-9 col-xs-push-3 test-connect">
          <button id="wm-security-ldap-test-connection" (click)="testConnection()" class="button-primary"
            name="wm-security-ldap-test-connection">{{locale.LABEL_TEST_CONNECTION}}</button>
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_ROLE}}</h5>

      <!-- Search User Role-->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3">{{locale.LABEL_SEARCH_USER_ROLE}}: </label>

        <div class="col-xs-9">
          <wms-toggle id="role-configuration-toggle" class="switch" name="wm-role-config"
            [model]="security.roleMappingEnabled" [onLabel]="'On'" [offLabel]="'Off'"
            (onChange)="security.roleMappingEnabled = $event;"></wms-toggle>
        </div>
      </div>
      <!-- Search User Role Options-->
      <div *ngIf="security.roleMappingEnabled">

        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3"
            for="wm-sec-select-search-user-role-provider">{{locale.LABEL_SELECT_USER_ROLE_PROVIDER}}: </label>

          <div class="col-xs-9">
            <select id="wm-sec-select-search-user-role-provider"  name="wm-sec-select-search-user-role-provider" class="form-control app-select"
              [(ngModel)]="security.roleProvider">
              <option *ngFor="let option of security.userLDAPRoleProviders">{{option}}</option>
            </select>
          </div>
        </div>

        <div [ngSwitch]="security.roleProvider">
          <div *ngSwitchCase="'LDAP'">
            <div class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-xs-3 required"
                for="wm-sec-grp-search-base">{{locale.LABEL_GROUP_SEARCH_BASE}}: </label>
              <div class="col-xs-9">
                <input name="wm-sec-grp-search-base" id="wm-sec-grp-search-base" placeholder={{security.placeholder.LDAP_groupSearchBase}}
                  class="form-control app-textbox" [(ngModel)]="security.groupSearchBase" />
              </div>
            </div>

            <div class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-xs-3 required"
                for="wm-sec-grp-role-attr">{{locale.LABEL_GROUP_ROLE_ATTRIBUTE}}: </label>

              <div class="col-xs-9">
                <input id="wm-sec-grp-role-attr" name="wm-sec-grp-role-attr" class="form-control app-textbox"
                  [(ngModel)]="security.ldapGroupRoleAttribute" />
              </div>
            </div>

            <div class="form-group app-composite-widget clearfix">
              <label class="control-label app-label col-xs-3 required"
                for="wm-sec-grp-search-filter">{{locale.LABEL_GROUP_SEARCH_FILTER}}: </label>

              <div class="col-xs-9">
                <input id="wm-sec-grp-search-filter" name="wm-sec-grp-search-filter" class="form-control app-textbox"
                  [(ngModel)]="security.groupSearchFilter" />
              </div>
            </div>
          </div>
          <div class="security-sub-category" *ngSwitchCase="'Database'">
            <!-- Roles By SQL Query -->
            <wms-database [securityProps]="securityProps" [authInfo]="authInfo"></wms-database>
          </div>
        </div>

      </div>
    </div>
  </div>
</form>